<template>
  <div class="colors">
    <div class="row">
      <div
        v-for="(color, index) in colors"
        :key="index"
        @click="selectColor({selectedColor: color.colorName})"
        v-scroll-to="'#app'"
        class="col-xs-6"
      >
        <div class="panel panel-default panel-color">
          <div class="panel-body">
            <div v-if="color.colorImage">
              <img class="color-image" :src="color.colorImage" />
            </div>
            <div v-else class="color" :style="'background-color: ' + color.colorHex + ';'"></div>
          </div>
          <div class="panel-footer">{{ color.colorName }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'Step3Color',
  computed: {
    colors: {
      get() {
        return this.$store.state.availableColors;
      },
    },
  },
  methods: {
    ...mapActions(['selectColor']),
  },
};
</script>
